<script>
import Swal from "sweetalert2";
import { ref } from "vue";

export default {
  props: {
    list: Array,
    height: Number,
  },

  setup(props) {
    const allAnswers = props.list.reduce((accumulator, currentValue) => {
      return [...accumulator, ...currentValue.jawaban];
    }, []);

    const items = ref(allAnswers.map((item) => ({ ...item, list: 1 })));

    const getList = (list) => {
      return items.value.filter((item) => item.list == list);
    };

    const startDrag = (event, item) => {
      console.log(item);
      event.dataTransfer.dropEffect = "move";
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("itemID", item.idjawaban);
    };

    const onDrop = (event, list) => {
      const itemID = event.dataTransfer.getData("itemID");
      const item = items.value.find((item) => item.idjawaban == itemID);
      if (list !== 1 && getList(list).length > 0) {
        // Swal.fire({
        //   icon: "warning",
        //   title: "Peringatan!",
        //   text: "Hanya satu jawaban yang diizinkan untuk dipilih!",
        // });
        console.log(`Hanya satu jawaban yang diizinkan untuk masuk!`);
        return;
      }
      
      item.list = list;
    };

    const onDragLeave = () => {
      // Lakukan apa pun yang diperlukan ketika data di-drag keluar tabel
      console.log("Data di-drag keluar tabel");
    };

    return {
      getList,
      onDrop,
      startDrag,
      onDragLeave,
    };
  },

  data() {
    return {
      idJawabanPetunjuk: 0,
      link: process.env.VUE_APP_BACKEND_URL,
    };
  },

  methods: {
    jawabanPetunjuk(id) {
      this.idJawabanPetunjuk = id;
    },
    selesai() {
      Swal.fire({
        icon: "warning",
        title: "Konfirmasi!",
        text: "Apakah Anda Yakin?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Ya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            icon: "success",
            title: "Selesai!",
            text: "Jawaban berhasil di simpan",
            timer: 2000,
            timerProgressBar: true,
          });
          this.modalProgress = false;
        } else {
          this.modalProgress = false;
        }
      });
    },
    clickJawaban(item) {
      console.log(item);
      if (this.getList(2).length > 0) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan!",
          text: "Hanya satu jawaban yang diizinkan untuk dipilih!",
        });
        return;
      }
      // Ubah posisi item ke list 2 (jawaban terpilih)
      item.list = 2;

      // Panggil function selectAnswer jika diperlukan
      
    },
    clickSelectedJawaban(item) {
      // Kembalikan item ke list 1 (opsi jawaban)
      item.list = 1;
    },
  },
};
</script>

<template>
  <div class="mym-question-body">
    <div class="mym-question-cardbox">
      <div class="mym-question-section">
        <h4>Petunjuk Menjodohkan</h4>

        <p>
          Silahkan pilih salah satu jawaban dengan klik pada pilihan jawaban
          yang tersedia.
        </p>

        <p>Klik "preview" untuk menampilkan gambar</p>

        <div class="mb-3">
          <b>Contoh Soal</b>

          <img
            v-if="list[0].soal_image"
            :src="link + list[0].soal_image"
            style="max-width: 70vw"
            class="mx-auto mb-2"
          />

          <div class="card border card-soal" style="background: #ecf0f1">
            <div class="card-body body-soal">
              <h5>Pertanyaan :</h5>
              {{ list[0].soal_text }}
            </div>
          </div>

          <table
            class="table align-middle table-nowrap table-striped table-bordered font-size-14"
          >
            <thead class="table-primary">
              <tr>
                <td width="5%" style="text-align: center">No</td>
                <td width="50%">Soal</td>
                <td width="35%">Jawab</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="soal in list" :key="soal.idsoal">
                <td width="5%" style="text-align: center">
                  {{ soal.nomor_urut }}
                </td>
                <td width="50%">{{ soal.pertanyaan }}</td>
                <td width="35%">
                  <div
                    class="drop-zone"
                    style="border-radius: 5px"
                    @drop="onDrop($event, 2)"
                    @dragenter.prevent
                    @dragover.prevent
                    @dragleave="onDragLeave"
                  >
                    <div
                      v-for="item in getList(2)"
                      :key="item.idjawaban"
                      style="border-radius: 5px"
                      class="drag-el"
                      draggable="true"
                      @dragstart="startDrag($event, item)"
                      @click="clickSelectedJawaban(item)"
                    >
                      {{ item.jawaban }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- ================= OPTIONS SECTION ================= -->
  <div
    class="mym-question-body answerlist-box"
    :style="{ top:0, height: `100%`}"
    style="max-width: 30%"
  >
    <div class="mym-question-cardbox" style="height: 100%;">
      <h4 class="mym-title-header">Pilihan Jawaban</h4>
      
      <div
        class="drop-zone pilihan-zone h-100"
        style="border-radius: 5px; max-height: 100%; overflow: auto"
        @drop="onDrop($event, 1)"
        @dragenter.prevent
        @dragover.prevent
      >
        <div
          v-for="item in getList(1)"
          :key="item.idjawaban"
          style="border-radius: 5px"
          class="drag-el m-2"
          draggable="true"
          @dragstart="startDrag($event, item)"
        >
          {{ item.jawaban }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scope>
.drop-zone {
  background-color: #ecf0f1;
  padding: 5px;
  min-height: 30px;
  text-align: center;
}
.drag-el {
  background-color: #556ee6;
  color: white;
  padding: 5px;
}
</style>